export default {
  current_style: 					[],
  colors_avoid:						[],
  patterns_avoid:					[],
  necklines:							[],
  top_half_fit:						[],
  sleeve_preference:			[],
  pant_fit:								[],
  dress_style:						[],
  items_avoid:						[],
  areas_conceal:					[]
}